export function initPokemonCard() {
    const pokemonCard = document.getElementById('pokemonCard');
    if (!pokemonCard) return;

    const cardContainer = pokemonCard.parentElement;
    let isMouseTracking = false;

    cardContainer.addEventListener('mouseenter', () => {
        isMouseTracking = true;
        pokemonCard.classList.add('mouse-tracking');
    });

    cardContainer.addEventListener('mouseleave', () => {
        isMouseTracking = false;
        pokemonCard.classList.remove('mouse-tracking');
        pokemonCard.style.transform = '';
    });

    cardContainer.addEventListener('mousemove', (e) => {
        if (!isMouseTracking) return;

        const rect = cardContainer.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        const mouseX = e.clientX - centerX;
        const mouseY = e.clientY - centerY;
        
        const rotateX = (mouseY / rect.height) * -30;
        const rotateY = (mouseX / rect.width) * 30;
        
        pokemonCard.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    });
}
